import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { globalKey } from 'data/sharedKeys';
import { retrieveToken } from '../services/auth.service';

const completeConfigurationPageRoute = '/setup/accountcreated';

const loggedIn = () => {
  const token = retrieveToken();
  if (token != null) {
    return true;
  }
  return false;
};

const UserRoute = ({
  component: Component, redirectRoute, location, carrierAccount, ...rest
}) => {
  const parsed = queryString.parse(location.search);
  return (
    <Route
      { ...rest }
      render={ (props) => {
        if (parsed.ssotoken && parsed.ssotoken.length > 0) {
          // detected SSO login request
          return (
            <Redirect to={ {
              pathname: '/sso',
              search: location.search
            } }
            />
          );
        }

        if (loggedIn()) {
          if ((!carrierAccount || !carrierAccount.IsConfigurationComplete) && location.pathname !== completeConfigurationPageRoute) {
            return <Redirect to={ completeConfigurationPageRoute } />;
          }
          return <Component { ...props } />;
        }

        return <Redirect to={ redirectRoute } />;
      } }
    />
  );
};

function mapStateToProps(state) {
  return { ...state.accounts[globalKey] };
}


export default connect(mapStateToProps)(UserRoute);
